/**
 * Portuguese (Brazil) translations for GameExplorerHub component
 */
export const gameExplorerHubPtBR = {
  // Header
  "INTELLIGENCE HUB": "CENTRAL DE INTELIGÊNCIA",
  "Advanced Analytics & Prediction Models": "Análise Avançada e Modelos de Previsão",
  
  // Professional Metrics
  "ACCURACY": "PRECISÃO",
  "GLOBAL COVERAGE": "COBERTURA GLOBAL",
  "ADVANCED AI": "IA AVANÇADA",
  "Average Level:": "Nível Médio:",
  "Global Coverage": "Cobertura Global",
  "Advanced AI": "IA Avançada",
  
  // Intelligence Modules Section
  "INTELLIGENCE MODULES": "MÓDULOS DE INTELIGÊNCIA",
  
  // Sports
  "BASEBALL": "BEISEBOL",
  "BEISEBOL": "BEISEBOL",
  "Beisebol": "Beisebol",
  "FOOTBALL": "FUTEBOL",
  "FUTEBOL": "FUTEBOL",
  "Futebol": "Futebol",
  "MMA": "MMA",
  
  // Baseball Metrics
  "MLB Coverage": "Cobertura MLB",
  "Complete": "Completa",
  "Model Type": "Tipo de Modelo",
  "Cognitive Model": "Modelo Cognitivo",
  "Accuracy": "Precisão",
  
  // Football Metrics
  "Global Leagues": "Ligas Globais",
  "50+ Covered": "50+ Cobertas",
  "103+ Covered": "103+ Cobertas",
  "103+ Ligas": "103+ Ligas",
  "103+ ligas": "103+ ligas",
  "AI Service Mesh": "Malha de Serviços IA",
  
  // MMA Metrics
  "UFC Events": "Eventos UFC",
  "Full Coverage": "Cobertura Total",
  "UFC": "UFC",
  
  // NFL Metrics
  "NFL": "NFL",
  "Season Coverage": "Cobertura da Temporada",
  
  // Additional Sports
  "ADDITIONAL SPORTS": "ESPORTES ADICIONAIS",
  "ESPORTES ADICIONAIS": "ESPORTES ADICIONAIS",
  "NBA": "NBA",
  "NHL": "NHL",
  "Tennis": "Tênis",
  "NCAAF": "NCAAF",
  "Advanced models in development": "Modelos avançados em desenvolvimento",
  
  // AI Prediction Suite
  "AI PREDICTION SUITE": "SUÍTE DE PREVISÃO IA",
  "SUÍTE DE PREVISÃO IA": "SUÍTE DE PREVISÃO IA",
  "Suíte de Previsão IA": "Suíte de Previsão IA",
  "7 Advanced Models": "7 Modelos Avançados",
  "7 modelos avançados": "7 modelos avançados",
  "Professional Analytics": "Análise Profissional",
  "Análise profissional": "Análise profissional",
  "Historical Performance": "Desempenho Histórico",
  
  // Navigation
  "Close": "Fechar",
  "Fechar": "Fechar",
  "Voltar": "Voltar",
  "Abrir módulo — ": "Abrir módulo — ",
  "Precisão": "Precisão",
  "Nível": "Nível",
  "Nível Médio:": "Nível Médio:",
  "Elite": "Elite",
  "Pro+": "Pro+",
  "Pro": "Pro",
  "Completa": "Completa",
  "CENTRAL DE INTELIGÊNCIA": "CENTRAL DE INTELIGÊNCIA",
  "Análise Avançada e Modelos de Previsão": "Análise Avançada e Modelos de Previsão",
  "MÓDULOS DE INTELIGÊNCIA": "MÓDULOS DE INTELIGÊNCIA",
  "Modelos avançados em desenvolvimento": "Modelos avançados em desenvolvimento",
  "Tênis": "Tênis",
  
  // Live indicators
  "Live now": "Ao vivo agora",

  // Sport module card translations
  "Open module": "Abrir módulo",
  "Coverage": "Cobertura",
  "Coverage:": "Cobertura:",
  "Model": "Modelo",
  "Model:": "Modelo:",
  "Level": "Nível",

  // Sports names for modules
  "Baseball": "Beisebol",
  "Soccer": "Futebol",
  "Complete": "Completa",
  "103+ Leagues": "103+ ligas"
};